import { useMemo } from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import { VideoFile } from 'src/components/VideoPromotion';

export const VIDEO_PROMOTION_QUERY = graphql`
  query VideoPromotion {
    sanityVideoPromotion(enable: { eq: true }) {
      ariaLabel: aria_label
      buttonLabel: button_label
      href
      htmlId: html_id
      posterImage: poster_image {
        asset {
          localFile {
            publicURL
          }
        }
      }
      desktopVideoFiles: desktop_video_files {
        asset {
          localFile {
            extension
            publicURL
          }
        }
      }
      mobileVideoFiles: mobile_video_files {
        asset {
          localFile {
            extension
            publicURL
          }
        }
      }
    }
  }
`;

type SanityVideoFile = {
  asset?: {
    localFile?: {
      extension?: string;
      publicURL?: string;
    };
  };
};

type PosterImage = {
  asset?: {
    localFile?: {
      publicURL?: string;
    };
  };
};

export type SanityVideoPromotion = {
  sanityVideoPromotion?: {
    ariaLabel?: string;
    buttonLabel?: string;
    href?: string;
    htmlId?: string;
    posterImage?: PosterImage;
    desktopVideoFiles?: SanityVideoFile[];
    mobileVideoFiles?: SanityVideoFile[];
  };
};

const transformVideoFile = (videoFile?: SanityVideoFile): VideoFile => {
  const localFile = videoFile?.asset?.localFile;
  const { extension, publicURL } = localFile || {};

  return { src: publicURL, type: `video/${extension}` };
};

const useVideoPromotion = () => {
  const { sanityVideoPromotion } = useStaticQuery<SanityVideoPromotion>(VIDEO_PROMOTION_QUERY) || {};

  return useMemo(() => {
    if (!sanityVideoPromotion) {
      return undefined;
    }

    const { ariaLabel, buttonLabel, href, htmlId } = sanityVideoPromotion;
    const desktopFiles = sanityVideoPromotion.desktopVideoFiles?.map(transformVideoFile);
    const mobileFiles = sanityVideoPromotion.mobileVideoFiles?.map(transformVideoFile);
    const posterImage = sanityVideoPromotion?.posterImage?.asset?.localFile?.publicURL;

    return { ariaLabel, buttonLabel, href, htmlId, posterImage, desktopFiles, mobileFiles };
  }, [sanityVideoPromotion]);
};

export default useVideoPromotion;
